import React, {Component} from "react";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Button} from "react-bootstrap";
import ActivityLogsTable from "./_components/ActivityLogsTable";

class ActivityLogsPage extends Component {
    state = {
        refresh: false,
    }

    componentDidMount() {
    }

    render() {
        const { t } = this.props;

        const breadcrumb = [
            { value: 'activity-logs', path: '#' },
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>

                <div className="card">
                    <div className="card-header">
                        <div className="button-group">

                            {/*<Button variant={"danger"} onClick={this.openClearLogModal}>*/}
                            {/*    <i className="fas fa-trash"/> &nbsp;*/}
                            {/*    {t('delete-logs')}*/}
                            {/*</Button>*/}
                        </div>
                    </div>
                    <div className="card-body">
                        <ActivityLogsTable />
                    </div>
                </div>
            </div>
        )
    }
}
export default ActivityLogsPage;
